import { render, staticRenderFns } from "./TMResultsTableWrapper.vue?vue&type=template&id=d18d8a76&scoped=true"
import script from "./TMResultsTableWrapper.vue?vue&type=script&lang=js"
export * from "./TMResultsTableWrapper.vue?vue&type=script&lang=js"
import style0 from "./TMResultsTableWrapper.vue?vue&type=style&index=0&id=d18d8a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18d8a76",
  null
  
)

export default component.exports